import {Client} from './client';
import {Deal} from './deal';
import {Rights} from '../../../models/user';

/** Фильтры списка клиентов/сделок, сохраняемые в IndexedDB. */
export type CrmListCacheFilters = {
    client_type?: string;
    [key: string]: string | number | boolean | undefined;
} | null;

/**
 * Интерфейс для хранения отдельного клиента в IndexedDB
 */
export interface CrmClientDbItem {
    id: string; // Ключ: 'client-{clientId}-{companyId}'
    data: Client; // Сериализованный объект Client
    timestamp: number; // Время кэширования
}

/**
 * Интерфейс для хранения списка клиентов в IndexedDB
 */
export interface CrmClientsListDbItem {
    id: string; // Ключ: 'clients-list-{companyId}-{filters}' или 'clients-list-{companyId}'
    data: Client[]; // Массив сериализованных объектов Client
    rights: Rights | null; // Права пользователя
    pagination?: {
        page: number;
        pageSize: number;
        total: number;
    } | null;
    filters?: CrmListCacheFilters; // Примененные фильтры
    timestamp: number; // Время кэширования
}

/**
 * Интерфейс для хранения отдельной сделки в IndexedDB
 */
export interface CrmDealDbItem {
    id: string; // Ключ: 'deal-{dealId}-{companyId}'
    data: Deal; // Сериализованный объект Deal
    timestamp: number; // Время кэширования
}

/**
 * Интерфейс для хранения списка сделок в IndexedDB
 */
export interface CrmDealsListDbItem {
    id: string; // Ключ: 'deals-list-{companyId}-{filters}' или 'deals-list-{companyId}'
    data: Deal[]; // Массив сериализованных объектов Deal
    rights: Rights | null; // Права пользователя
    pagination?: {
        page: number;
        pageSize: number;
        total: number;
    };
    filters?: CrmListCacheFilters; // Примененные фильтры
    timestamp: number; // Время кэширования
}

/**
 * Конфигурация хранилища IndexedDB для отдельного клиента
 */
export const crmClientDb = {
    store: 'crm-client',
    storeConfig: {keyPath: 'id', autoIncrement: false},
    storeSchema: [
        {name: 'data', keypath: 'data', options: {unique: false}},
        {name: 'timestamp', keypath: 'timestamp', options: {unique: false}},
    ]
};

/**
 * Конфигурация хранилища IndexedDB для списка клиентов
 */
export const crmClientsListDb = {
    store: 'crm-clients-list',
    storeConfig: {keyPath: 'id', autoIncrement: false},
    storeSchema: [
        {name: 'data', keypath: 'data', options: {unique: false}},
        {name: 'rights', keypath: 'rights', options: {unique: false}},
        {name: 'pagination', keypath: 'pagination', options: {unique: false}},
        {name: 'filters', keypath: 'filters', options: {unique: false}},
        {name: 'timestamp', keypath: 'timestamp', options: {unique: false}},
    ]
};

/**
 * Конфигурация хранилища IndexedDB для отдельной сделки
 */
export const crmDealDb = {
    store: 'crm-deal',
    storeConfig: {keyPath: 'id', autoIncrement: false},
    storeSchema: [
        {name: 'data', keypath: 'data', options: {unique: false}},
        {name: 'timestamp', keypath: 'timestamp', options: {unique: false}},
    ]
};

/**
 * Конфигурация хранилища IndexedDB для списка сделок
 */
export const crmDealsListDb = {
    store: 'crm-deals-list',
    storeConfig: {keyPath: 'id', autoIncrement: false},
    storeSchema: [
        {name: 'data', keypath: 'data', options: {unique: false}},
        {name: 'rights', keypath: 'rights', options: {unique: false}},
        {name: 'pagination', keypath: 'pagination', options: {unique: false}},
        {name: 'filters', keypath: 'filters', options: {unique: false}},
        {name: 'timestamp', keypath: 'timestamp', options: {unique: false}},
    ]
};
